export default "__VITE_ASSET__BTy0Rlm8__"